import RequestToPayBlock from './request-to-pay-block';

export default RequestToPayBlock;
